/** @format */

import React, { useState } from 'react'
import { _$, Tabs, Tab } from '@king-design/react'
import styled from 'styled-components'
import { CustomPageContainer } from 'src/components'
import PythonLogo from 'src/assets/img/Python.png'
import PythonAccess from './components/PythonAccess'
import useNavRegion from 'src/hooks/useNavRegion'
import variable from 'src/static/styles/var'

type TabType = 'python'

const AccessCenter: React.FC<{ className?: string }> = ({ className }) => {
  const [tab, setTab] = useState<TabType>('python')
  // 控制台region
  const region = useNavRegion()
  return (
    <div className={className}>
      <CustomPageContainer
        title={_$('接入中心')}
        content={
          <Tabs value={tab} onChangeValue={setTab}>
            <Tab value="python">
              <img width={14} height={14} src={PythonLogo} alt="Python" />
              <span style={{ marginLeft: '8px' }}>{_$('Python')}</span>
            </Tab>
          </Tabs>
        }
      >
        {tab === 'python' ? <PythonAccess region={region} /> : null}
      </CustomPageContainer>
    </div>
  )
}

export default styled(AccessCenter)`
  p {
    color: ${variable.descColor};
  }
  .k-step {
    .k-step-mark,
    .k-step-tail {
      background: #0091ea !important;
      color: #0091ea !important;
      border-color: #0091ea !important;
    }
    .k-step-title {
      font-weight: 400 !important;
    }
  }
  .sub-title {
    font-weight: 500;
    color: ${variable.fontColor};
    margin-bottom: 0;
  }
  .k-tag {
    margin: 0 4px;
  }
  .custom-page-header {
    padding-bottom: 0;
    .k-tab {
      font-size: 14px;
    }
  }
`
